import {Typography} from '@mui/material'

export default ({children, required}) => (
    <Typography variant="inputLabel" color="text.secondary">
        {children}
        {required && (
            <>
                {' '}
                <Typography variant="inputLabel" color="error">
                    *
                </Typography>
            </>
        )}
    </Typography>
)
